// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"8cbef63409f5a06c88ad","691":"79c809fc471e401caf41"}[chunkId] + ".js";
};